export default "__VITE_ASSET__Dqr0bEEB__"